(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-analytics.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-analytics.js');
"use strict";


const {
  transaction: Transaction,
  transactionItem: TransactionItem,
  trackTransaction
} = svs.components.analytics;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_analytics = () => data => {
  var _placedBet;
  let placedBet = data;
  if (Array.isArray(data) && data.length === 1 && typeof data[0] === 'object') {
    placedBet = data[0];
  }
  if (((_placedBet = placedBet) === null || _placedBet === void 0 ? void 0 : _placedBet.event) === 'sbtech_analytics.placeBet') {
    const totalCost = placedBet.value;
    const numSelections = placedBet.selections.length;
    const costPerSelection = totalCost / numSelections;
    const items = placedBet.selections.map(selection => new TransactionItem('EXTOX', 'Oddset', costPerSelection, 1, {
      system: placedBet.type,
      odds: selection.odds,
      isLive: selection.isLive,
      event: selection.event,
      league: selection.league,
      sport: selection.sport
    }));
    const transaction = new Transaction(placedBet.id, totalCost, items, 0, 0, undefined, 'Oddset');
    trackTransaction(transaction);
  }
};

 })(window);